import '../GraphSidePanel.css';

import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { GraphNetworkViewerDataInput } from 'components/Graph/GraphSidePanel/GraphNetworkViewerDataInput/GraphNetworkViewerDataInput';
import type { NetworkViewerTabId } from 'components/Graph/GraphSidePanelData';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { TabView } from 'components/Tabs/TabView';
import { useLocale } from 'containers/App/LocaleContext';
import { memo } from 'react';
import { disableFormSubmitOnEnter } from 'utils/dom/disableFormSubmitOnEnter';
import { useNetworkViewerDataInput } from '../GraphNetworkViewerDataInput/useNetworkViewerDataInput';
import { useStpInstances } from '../TopologyLayoutSettingsProtocolsProtocol/useStpInstances';
import { TopologyVisualizationSetup } from '../TopologyVisualizationSetup';
import { GraphNetworkViewerSubmitButton } from './GraphNetworkViewerSubmitButton';

const BareGraphNetworkViewer = () => {
  const msg = useLocale();

  const networkViewerDataInputHook = useNetworkViewerDataInput();
  const stpInstancesHook = useStpInstances();

  const tabs = [
    {
      key: 'dataInput',
      label: msg.canvasGraph.graphSidePanel.networkViewer.tabs.dataInput,

      render: () => (
        <GraphNetworkViewerDataInput
          networkViewerDataInputHook={networkViewerDataInputHook}
        />
      ),
    },
    {
      key: 'visualizationSetup',
      label:
        msg.canvasGraph.graphSidePanel.networkViewer.tabs.visualizationSetup,

      render: () => (
        <TopologyVisualizationSetup stpInstancesHook={stpInstancesHook} />
      ),
    },
  ] as const;

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    presetEditMode: prop('layoutSettings', 'presetEditMode'),
    tabId: prop('sidePanel', 'networkViewerTabId'),
  });

  return (
    <div className='graph-side-panel-tabbed-content flex flex-1 flex-col'>
      <form
        className='flex flex-1 flex-col'
        onSubmit={networkViewerDataInputHook.formik.handleSubmit}
        onKeyPress={disableFormSubmitOnEnter}
      >
        <TabView<NetworkViewerTabId>
          activeTab={ctxProps.tabId}
          onChangeTab={(networkViewerTabId) => {
            ctxProps.dispatch(showSidePanel, { networkViewerTabId });
          }}
          stretch
          tabs={tabs}
          className='graph-side-panel-tabs-cards pb-lgu-3'
          variant='legacy'
        />
        {!ctxProps.presetEditMode &&
          networkViewerDataInputHook.pathLayoutEdit === null && (
            <GraphNetworkViewerSubmitButton />
          )}
      </form>
    </div>
  );
};

export const GraphNetworkViewer = memo(BareGraphNetworkViewer);
